import constants from "../config/constants";
import { postRequest } from "../libs/AxiosService.util";

export async function serviceGetIdCardList(params) {
  return await postRequest("employees/id/card/list/new", params);
}
export async function serviceDownloadEmpsIdCards (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"employees/id/card/csv/new", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
      ...(constants.CLIENT_TOKEN ? { 'x-client-token': constants.CLIENT_TOKEN } : {}),
    },
    body: JSON.stringify({
      ...params
    }),
  });
}